"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _actionUtils = require("../../../utils/actionUtils");
var _syncFeaturedPresenter = _interopRequireDefault(require("../../../actions/program/syncFeaturedPresenter"));
var _getSources = _interopRequireDefault(require("../../../actions/source/getSources"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function sourceOrderChanged(_ref, _ref2) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  var presenterId = _ref2.presenterId,
    isPresenterSource = _ref2.isPresenterSource,
    notifyingDirector = _ref2.notifyingDirector;
  if (!(0, _actionUtils.isSameAttendee)(notifyingDirector, getState())) {
    if (isPresenterSource) {
      dispatch((0, _syncFeaturedPresenter["default"])(presenterId));
    } else {
      // sync sources
      dispatch((0, _getSources["default"])());
    }
  }
}
var _default = exports["default"] = sourceOrderChanged;